import React from 'react';
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerFooter } from '@/components/ui/drawer';
import { Button } from '@/components/ui/button';
import { IconShare2 } from '@tabler/icons-react';
import { MdOutlineAddBox } from "react-icons/md";
import { useTranslation } from 'next-i18next';
import { Separator } from '@components/ui/separator';
type IOSInstallPromptProps = {
  forceVisible?: boolean;
  onDismiss?: () => void;
};
const IOSInstallPrompt: React.FC<IOSInstallPromptProps> = ({
  forceVisible = false,
  onDismiss
}) => {
  const {
    t
  } = useTranslation('common');
  const [visible, setVisible] = React.useState(false);
  React.useEffect(() => {
    if (forceVisible) {
      setVisible(true);
      return;
    }
    const isIOS = () => typeof window !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window.navigator && 'msSaveBlob' in window.navigator);
    const isInStandaloneMode = () => window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone === true;
    const dismissed = localStorage.getItem('ios-pwa-prompt-dismissed');
    if (isIOS() && !isInStandaloneMode() && !dismissed) {
      setVisible(true);
    }
  }, [forceVisible]);
  const dismissPrompt = () => {
    setVisible(false);
    localStorage.setItem('ios-pwa-prompt-dismissed', 'true');
    if (onDismiss) {
      onDismiss();
    }
  };
  return <Drawer open={visible} onOpenChange={open => {
    if (!open) dismissPrompt();
  }} data-sentry-element="Drawer" data-sentry-component="IOSInstallPrompt" data-sentry-source-file="ios-install-pwa.tsx">
      <DrawerContent className="fixed bottom-0 left-0 right-0 border-t border-neutral-300 dark:border-neutral-800 shadow-lg p-6 rounded-t-xl" data-sentry-element="DrawerContent" data-sentry-source-file="ios-install-pwa.tsx">
        <DrawerHeader className="p-2 mb-4" data-sentry-element="DrawerHeader" data-sentry-source-file="ios-install-pwa.tsx">
          <DrawerTitle className="text-neutral-900 dark:text-neutral-200 text-2xl p-2" data-sentry-element="DrawerTitle" data-sentry-source-file="ios-install-pwa.tsx">
            {t('text-pwa-title')}
          </DrawerTitle>
          <Separator className="my-2 bg-neutral-300 dark:bg-neutral-800" data-sentry-element="Separator" data-sentry-source-file="ios-install-pwa.tsx" />
          <p className="text-neutral-700 dark:text-neutral-600 text-lg p-2">
            {t('text-pwa-body')}
          </p>
          <Separator className="my-2 bg-neutral-300 dark:bg-neutral-800" data-sentry-element="Separator" data-sentry-source-file="ios-install-pwa.tsx" />
        </DrawerHeader>
        <div className="text-neutral-300 dark:text-neutral-200 text-lg space-y-3 item-center mx-auto">
          <div className="flex items-center gap-2">
            <IconShare2 stroke={2} size={32} className="text-blue-500 mr-6" data-sentry-element="IconShare2" data-sentry-source-file="ios-install-pwa.tsx" />
            <span className='text-neutral-600 dark:text-neutral-600'>{t('text-pwa-share')}</span>
          </div>
          <div className="flex items-center gap-2">
            <MdOutlineAddBox size={32} className="text-neutral-900 dark:text-neutral-200 mr-6" data-sentry-element="MdOutlineAddBox" data-sentry-source-file="ios-install-pwa.tsx" />
            <span className='text-neutral-600 dark:text-neutral-600'>{t('text-pwa-addhome')}</span>
          </div>
        </div>

        <DrawerFooter className="mt-6 p-0" data-sentry-element="DrawerFooter" data-sentry-source-file="ios-install-pwa.tsx">
          <Button onClick={dismissPrompt} data-sentry-element="Button" data-sentry-source-file="ios-install-pwa.tsx">
            {t('text-pwa-close')}
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>;
};
export default IOSInstallPrompt;